"use strict";
/*
 * Copyright (C) 2018 Spanning Cloud Apps.  All rights reserved.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertRuleTriggerValueType = void 0;
/**
 * When an Alert Rule is defined, the rule can be configured to look for changes in the number of backed up objects from
 * one backup to the next. The change can be represented as a count or a percent.
 */
var AlertRuleTriggerValueType;
(function (AlertRuleTriggerValueType) {
    AlertRuleTriggerValueType["COUNT"] = "count";
    AlertRuleTriggerValueType["PERCENT"] = "percent";
})(AlertRuleTriggerValueType || (exports.AlertRuleTriggerValueType = AlertRuleTriggerValueType = {}));
//# sourceMappingURL=AlertRuleTriggerValueType.js.map